import { sendApiRequest } from '../../../shared/api/apiConfig';
import type { AdminDailyAnalyticsResponse } from '../domain/adminAnalytics';
import type { AdminOwnerDailyAnalyticsResponse } from '../domain/adminOwnerAnalytics';

export const getAdminDailyAnalytics = async (
  from: string,
  to: string,
): Promise<AdminDailyAnalyticsResponse> => {
  const params = new URLSearchParams({ from, to });
  return sendApiRequest<AdminDailyAnalyticsResponse>(
    'get',
    `/api/v1/admin/analytics/daily?${params.toString()}`,
  );
};

export const getAdminOwnerDailyAnalytics = async (
  from: string,
  to: string,
): Promise<AdminOwnerDailyAnalyticsResponse> => {
  const params = new URLSearchParams({ from, to });
  return sendApiRequest<AdminOwnerDailyAnalyticsResponse>(
    'get',
    `/api/v1/admin/analytics/owner-activity/daily?${params.toString()}`,
  );
};
